<template>
  <div>
    <!-- :expand-config="{ reserve: true }" -->
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      row-id="lineCode"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :checkbox-config="{
        reserve: true,
        highlight: false,
        checkMethod: setCanCheck
      }"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.lineStatus === 'Y'
              ? 'success'
              : row.lineStatus === 'N'
              ? 'light'
              : 'warning'
          "
        >
          {{ row.lineStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  code: row.lineCode
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            v-allow="'actModify'"
            placement="top"
            v-if="row.lineStatus === 'N'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  code: row.lineCode
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            v-allow="'actDel'"
            placement="top"
            v-if="row.lineStatus === 'N'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.lineCode)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="审核"
            v-allow="'actAudit'"
            placement="top"
            v-if="row.lineStatus === 'N'"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="audit(row.lineCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <!-- <template v-slot:content="{ row }">
        <table-point
          ref="tablePoint"
          :lineCode="row.lineCode"
          @openEditPointDialog="openEditPointDialog"
        />
      </template> -->
    </vxe-grid>

    <el-dialog
      v-if="editPointDialogOptions.visible"
      v-el-dialog-drag
      visible
      show-close
      width="800px"
      :title="editPointDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editPoint.cancel()"
    >
      <edit-Point
        ref="editPoint"
        :disabled="editPointDialogOptions.disabled"
        :linePointCode="editPointDialogOptions.code"
        @reload="() => this.$refs.tablePoint.getData()"
        @close="closeEditPointDialog"
      >
      </edit-Point>
      <span slot="footer">
        <el-button size="small" @click="$refs.editPoint.cancel()"
          >取消</el-button
        >
        <el-button
          v-if="!editPointDialogOptions.disabled"
          type="primary"
          size="small"
          @click="$refs.editPoint.save()"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
// import TablePoint from '../table-point'
import editPoint from '../edit-form/edit-point'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {
    editPoint
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(),
      editPointDialogOptions: {
        visible: false,
        code: ''
      }
    }
  },

  methods: {
    setCanCheck({ row }) {
      return row.lineStatus === 'N'
    },
    openEditPointDialog({ type, code = '' }) {
      const types = {
        edit: '编辑线路信息',
        add: '添加线路节点信息',
        detail: '线路节点信息详情'
      }
      this.editPointDialogOptions = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail'
      }
    },
    closeEditPointDialog() {
      this.editPointDialogOptions.visible = false
    },
    del(code) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning'
      }).then(() => {
        this.$api.contractLineDelApi({ lineCode: code }).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          })
          this.$emit('reload')
        })
      })
    },
    audit(code) {
      this.$confirm('确认要审核通过该记录吗？', '确认信息', {
        type: 'warning'
      }).then(() => {
        this.$api.contractAuditDelApi({ lineCode: code }).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          })
          this.$emit('reload')
        })
      })
    },
    openEditPage({ pageType, code }) {
      this.$router.push({
        name: 'contract-line-detail',
        params: { lineCode: code, pageType }
      })
    }
  }
}
</script>
